import React, { Component } from 'react';
import { notification, Modal, Input, Checkbox, Button } from 'antd/lib';
import { withApollo, graphql, compose } from 'react-apollo';
import { Form } from '@ant-design/compatible';

import FormFinalizarAcuerdo from './FormFinalizarAcuerdo';

import finalizarAcuerdoExtrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/finalizarAcuerdoExtrajudicial.graphql';

@compose(
  graphql(finalizarAcuerdoExtrajudicial, {
    name: 'finalizarAcuerdoExtrajudicial',
  })
)
class ModalFinalizarAcuerdo extends Component {
  state = {
    finalizandoAcuerdo: false,
  };

  handleOk = datos => {
    this.setState({
      finalizandoAcuerdo: true,
    });

    this.props
      .finalizarAcuerdoExtrajudicial({
        variables: {
          _id: this.props.idAcuerdo,
          hayAcuerdo: datos.hayAcuerdo,
          observacionFinalizado: datos.observaciones,
        },
      })
      .then(res => {
        this.setState({
          finalizandoAcuerdo: false,
        });

        notification.success({
          message: 'El acuerdo se ha actualizado correctamente.',
        });

        // si esta funcion recibe "true" vuelve a llamar getAcuerdo y actualiza la vista
        this.props.ocultarModalFinalizar(true);
      })
      .catch(err => {
        console.log('ERROR', err);
        this.setState({
          finalizandoAcuerdo: false,
        });

        notification.error({
          message:
            'Error a la hora de finalizar el acuerdo, intente nuevamente.',
        });
      });
  };

  render() {
    return (
      <div>
        <Modal
          title="Finalizar Acuerdo Extrajudicial"
          visible={this.props.visibleModalFinalizar}
          onCancel={this.props.ocultarModalFinalizar}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormFinalizarAcuerdo
            onSubmit={this.handleOk}
            finalizandoAcuerdo={this.state.finalizandoAcuerdo}
          />
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalFinalizarAcuerdo);
